export const Privileges = {
  // Module Admins START
  MaintenanceAdmin: 'MAINTENANCE_ADMIN',
  OrdersAdmin: 'ORDERS_ADMIN',
  DocumentsAdmin: 'DOCUMENTS_ADMIN',
  NonConformancesAdmin: 'NON-CONFORMANCES_ADMIN',
  DrillsAdmin: 'DRILLS_ADMIN',
  TasksAdmin: 'TASKS_ADMIN',
  MedicinesAdmin: 'MEDICINES_ADMIN',
  StorageAdmin: 'STORAGE_ADMIN',
  RiskAssessmentsAdmin: 'RISK-ASSESSMENTS_ADMIN',
  CrewManagementAdmin: 'CREW-MANAGEMENT_ADMIN',
  CertificatesAdmin: 'CERTIFICATES_ADMIN',
  CompetencesAdmin: 'COMPETENCES_ADMIN',
  QHSEAdmin: 'QHSE_ADMIN',
  MessagesAdmin: 'MESSAGES_ADMIN',
  // Module Admins END

  // Work and Rest START
  WorkOverviewRead: 'WORK-OVERVIEW_READ',
  OvertimeTypeRead: 'OVERTIME-TYPE_READ',
  OvertimeTypeCreate: 'OVERTIME-TYPE_CREATE',
  OvertimeTypeUpdate: 'OVERTIME-TYPE_UPDATE',
  OvertimeTypeDelete: 'OVERTIME-TYPE_DELETE',
  WorkPlanTemplateRead: 'WORK-PLAN-TEMPLATE_READ',
  WorkPlanTemplateCreate: 'WORK-PLAN-TEMPLATE_CREATE',
  WorkPlanTemplateUpdate: 'WORK-PLAN-TEMPLATE_UPDATE',
  WorkPlanTemplateDelete: 'WORK-PLAN-TEMPLATE_DELETE',
  WorkPlanRead: 'WORK-PLAN_READ',
  WorkPlanCreate: 'WORK-PLAN_CREATE',
  WorkPlanUpdate: 'WORK-PLAN_UPDATE',
  WorkPlanDelete: 'WORK-PLAN_DELETE',
  ScheduleTemplateRead: 'SCHEDULE-TEMPLATE_READ',
  ScheduleTemplateCreate: 'SCHEDULE-TEMPLATE_CREATE',
  ScheduleTemplateUpdate: 'SCHEDULE-TEMPLATE_UPDATE',
  ScheduleTemplateDelete: 'SCHEDULE-TEMPLATE_DELETE',
  PlannedActivityScheduleTemplateRead: 'PLANNED-ACTIVITY-SCHEDULE-TEMPLATE_READ',
  PlannedActivityScheduleTemplateCreate: 'PLANNED-ACTIVITY-SCHEDULE-TEMPLATE_CREATE',
  PlannedActivityScheduleTemplateUpdate: 'PLANNED-ACTIVITY-SCHEDULE-TEMPLATE_UPDATE',
  PlannedActivityScheduleTemplateDelete: 'PLANNED-ACTIVITY-SCHEDULE-TEMPLATE_DELETE',
  PlannedActivitySignOffPeriodAdmin: 'PLANNED-ACTIVITY-SIGN-OFF-PERIOD_ADMIN',
  PlannedActivitySignOffPeriodReopen: 'PLANNED-ACTIVITY-SIGN-OFF-PERIOD_REOPEN',
  AdditionalTimeReadAllUsers: 'ADDITIONAL-TIME_READALLUSERS',
  AdditionalTimeApprove: 'ADDITIONAL-TIME_APPROVE',
  AdditionalTimeDeny: 'ADDITIONAL-TIME_DENY',
  AdditionalTimeCreate: 'ADDITIONAL-TIME_CREATE',
  AdditionalTimeUpdate: 'ADDITIONAL-TIME_UPDATE',
  AdditionalTimeDelete: 'ADDITIONAL-TIME_DELETE',
  UpdateAfterApproval: 'ADDITIONAL-TIME_UPDATEAFTERAPPROVAL',
  DeleteAfterApproval: 'ADDITIONAL-TIME_DELETEAFTERAPPROVAL',
  // Work and Rest END

  // Orders START
  OrderRead: 'ORDER_READ',
  OrderCreate: 'ORDER_CREATE',
  OrderUpdate: 'ORDER_UPDATE',
  OrderDelete: 'ORDER_DELETE',
  OrderPrint: 'ORDER_PRINT',
  OrderReport: 'ORDER_REPORT',
  OrderTypeRead: 'ORDER-TYPE_READ',
  OrderTypeCreate: 'ORDER-TYPE_CREATE',
  OrderTypeUpdate: 'ORDER-TYPE_UPDATE',
  OrderTypeDelete: 'ORDER-TYPE_DELETE',
  SupplierRead: 'SUPPLIER_READ',
  SupplierCreate: 'SUPPLIER_CREATE',
  SupplierUpdate: 'SUPPLIER_UPDATE',
  SupplierDelete: 'SUPPLIER_DELETE',
  PurchaserRead: 'PURCHASER_READ',
  PurchaserCreate: 'PURCHASER_CREATE',
  PurchaserUpdate: 'PURCHASER_UPDATE',
  PurchaserDelete: 'PURCHASER_DELETE',
  AccountRead: 'ACCOUNT_READ',
  AccountCreate: 'ACCOUNT_CREATE',
  AccountUpdate: 'ACCOUNT_UPDATE',
  AccountDelete: 'ACCOUNT_DELETE',
  AccountGroupRead: 'ACCOUNT-GROUP_READ',
  AccountGroupCreate: 'ACCOUNT-GROUP_CREATE',
  AccountGroupUpdate: 'ACCOUNT-GROUP_UPDATE',
  AccountGroupDelete: 'ACCOUNT-GROUP_DELETE',
  DeliveryConditionRead: 'DELIVERY-CONDITION_READ',
  DeliveryConditionCreate: 'DELIVERY-CONDITION_CREATE',
  DeliveryConditionUpdate: 'DELIVERY-CONDITION_UPDATE',
  DeliveryConditionDelete: 'DELIVERY-CONDITION_DELETE',
  DeliveryAddressRead: 'DELIVERY-ADDRESS_READ',
  DeliveryAddressCreate: 'DELIVERY-ADDRESS_CREATE',
  DeliveryAddressUpdate: 'DELIVERY-ADDRESS_UPDATE',
  DeliveryAddressDelete: 'DELIVERY-ADDRESS_DELETE',
  OrdersSettingsRead: 'ORDERS-SETTINGS_READ',
  OrdersSettingsUpdate: 'ORDERS-SETTINGS_UPDATE',
  SfiCodeDefinitionRead: 'ORDER-SFI-CODE-DEFINITION_READ',
  SfiCodeDefinitionCreate: 'ORDER-SFI-CODE-DEFINITION_CREATE',
  SfiCodeDefinitionUpdate: 'ORDER-SFI-CODE-DEFINITION_UPDATE',
  SfiCodeDefinitionDelete: 'ORDER-SFI-CODE-DEFINITION_DELETE',
  // Orders END

  // Certificate START
  CertificateRead: 'CERTIFICATE_READ',
  CertificateCreate: 'CERTIFICATE_CREATE',
  CertificateUpdate: 'CERTIFICATE_UPDATE',
  CertificateDelete: 'CERTIFICATE_DELETE',
  CertificateRenew: 'CERTIFICATE_RENEW',
  CertificateRestore: 'CERTIFICATE_RESTORE',
  CertificateTypeRead: 'CERTIFICATE-TYPE_READ',
  CertificateTypeCreate: 'CERTIFICATE-TYPE_CREATE',
  CertificateTypeUpdate: 'CERTIFICATE-TYPE_UPDATE',
  CertificateTypeDelete: 'CERTIFICATE-TYPE_DELETE',
  // Certificate END

  // Non-Conformance START
  NonConformanceRead: 'NON-CONFORMANCE_READ',
  NonConformanceCreate: 'NON-CONFORMANCE_CREATE',
  NonConformanceUpdate: 'NON-CONFORMANCE_UPDATE',
  NonConformanceDelete: 'NON-CONFORMANCE_DELETE',
  NonConformancePrint: 'NON-CONFORMANCE_PRINT',
  NonConformanceDelegate: 'NON-CONFORMANCE_DELEGATE',
  NonConformanceComplete: 'NON-CONFORMANCE_COMPLETE',
  NonConformanceReject: 'NON-CONFORMANCE_REJECT',
  NonConformanceClose: 'NON-CONFORMANCE_CLOSE',
  NonConformanceReopen: 'NON-CONFORMANCE_REOPEN',
  NonConformanceSign: 'NON-CONFORMANCE_SIGN',
  NonConformanceReport: 'NON-CONFORMANCE_REPORT',
  NonConformanceRestore: 'NON-CONFORMANCE_RESTORE',
  NonConformanceEnable: 'NON-CONFORMANCE_ENABLE',
  NonConformanceDisable: 'NON-CONFORMANCE_DISABLE',
  NonConformanceUpdateLog: 'NON-CONFORMANCE_UPDATELOG',
  NonConformanceTypeRead: 'NON-CONFORMANCE-TYPE_READ',
  NonConformanceTypeCreate: 'NON-CONFORMANCE-TYPE_CREATE',
  NonConformanceTypeUpdate: 'NON-CONFORMANCE-TYPE_UPDATE',
  NonConformanceTypeDelete: 'NON-CONFORMANCE-TYPE_DELETE',
  SeverityRead: 'SEVERITY_READ',
  SeverityCreate: 'SEVERITY_CREATE',
  SeverityUpdate: 'SEVERITY_UPDATE',
  SeverityDelete: 'SEVERITY_DELETE',
  NonConformanceSeaStateRead: 'NON-CONFORMANCE-SEA-STATE_READ',
  NonConformanceSeaStateCreate: 'NON-CONFORMANCE-SEA-STATE_CREATE',
  NonConformanceSeaStateUpdate: 'NON-CONFORMANCE-SEA-STATE_UPDATE',
  NonConformanceSeaStateDelete: 'NON-CONFORMANCE-SEA-STATE_DELETE',
  NonConformanceWeatherInformationRead: 'NON-CONFORMANCE-WEATHER-INFORMATION_READ',
  NonConformanceWeatherInformationCreate: 'NON-CONFORMANCE-WEATHER-INFORMATION_CREATE',
  NonConformanceWeatherInformationUpdate: 'NON-CONFORMANCE-WEATHER-INFORMATION_UPDATE',
  NonConformanceWeatherInformationDelete: 'NON-CONFORMANCE-WEATHER-INFORMATION_DELETE',
  NonConformanceLocationRead: 'NON-CONFORMANCE-LOCATION_READ',
  NonConformanceLocationCreate: 'NON-CONFORMANCE-LOCATION_CREATE',
  NonConformanceLocationUpdate: 'NON-CONFORMANCE-LOCATION_UPDATE',
  NonConformanceLocationDelete: 'NON-CONFORMANCE-LOCATION_DELETE',
  NonConformanceCauseRead: 'NON-CONFORMANCE-CAUSE_READ',
  NonConformanceCauseCreate: 'NON-CONFORMANCE-CAUSE_CREATE',
  NonConformanceCauseUpdate: 'NON-CONFORMANCE-CAUSE_UPDATE',
  NonConformanceCauseDelete: 'NON-CONFORMANCE-CAUSE_DELETE',
  CustomPropertyDefinitionRead: 'CUSTOM-PROPERTY-DEFINITION_READ',
  CustomPropertyDefinitionCreate: 'CUSTOM-PROPERTY-DEFINITION_CREATE',
  CustomPropertyDefinitionUpdate: 'CUSTOM-PROPERTY-DEFINITION_UPDATE',
  CustomPropertyDefinitionDelete: 'CUSTOM-PROPERTY-DEFINITION_DELETE',
  CustomPropertyDefinitionRestore: 'CUSTOM-PROPERTY-DEFINITION_RESTORE',
  NonConformanceReportSettingsUpdate: 'NON-CONFORMANCE-SETTINGS_UPDATE',
  CustomPropertyRead: 'CUSTOM-PROPERTY_READ',
  CustomPropertyCreate: 'CUSTOM-PROPERTY_CREATE',
  CustomPropertyUpdate: 'CUSTOM-PROPERTY_UPDATE',
  CustomPropertyDelete: 'CUSTOM-PROPERTY_DELETE',
  CustomPropertyRestore: 'CUSTOM-PROPERTY_RESTORE',
  // Non-Conformance END

  // Permit to Work START
  PermitToWorkRead: 'PTW_READ',
  PermitToWorkCreate: 'PTW_CREATE',
  PermitToWorkUpdate: 'PTW_UPDATE',
  // Tenant administration of types, location types, and Toolbox Talk settings.
  PermitToWorkSettings: 'PTW_SETTINGS',
  PermitToWorkTypeRead: 'PTW_SETTINGS',
  PermitToWorkTypeCreate: 'PTW_SETTINGS',
  PermitToWorkTypeUpdate: 'PTW_SETTINGS',
  PermitToWorkTypeDelete: 'PTW_SETTINGS',
  PermitToWorkLocationTypeRead: 'PTW_SETTINGS',
  PermitToWorkLocationTypeCreate: 'PTW_SETTINGS',
  PermitToWorkLocationTypeUpdate: 'PTW_SETTINGS',
  PermitToWorkLocationTypeDelete: 'PTW_SETTINGS',
  ToolboxTalkSettingsRead: 'PTW_SETTINGS',
  ToolboxTalkSettingsUpdate: 'PTW_SETTINGS',
  // Permit to Work END

  // Document START
  DocumentCreate: 'DOCUMENT_CREATE',
  DocumentDelete: 'DOCUMENT_DELETE',
  DocumentRead: 'DOCUMENT_READ',
  DocumentUpdate: 'DOCUMENT_UPDATE',
  DocumentEnable: 'DOCUMENT_ENABLE',
  DocumentDisable: 'DOCUMENT_DISABLE',
  DocumentReadAllStatuses: 'DOCUMENT_READALLSTATUSES',
  DocumentSettingsRead: 'DOCUMENT-SETTINGS_READ',
  DocumentSettingsUpdate: 'DOCUMENT-SETTINGS_UPDATE',
  DocumentPrintTextControlOnly: 'DOCUMENT_PRINTTEXTCONTROLONLY',
  DocumentSetRevisionNumber: 'DOCUMENT_SETREVISIONNUMBER',
  // Document END

  // Medicine START
  MedicineRead: 'MEDICINE_READ',
  MedicineCreate: 'MEDICINE_CREATE',
  MedicineUpdate: 'MEDICINE_UPDATE',
  MedicineDelete: 'MEDICINE_DELETE',
  MedicineReport: 'MEDICINE_REPORT',
  MedicineCategoryRead: 'MEDICINE-CATEGORY_READ',
  MedicineCategoryCreate: 'MEDICINE-CATEGORY_CREATE',
  MedicineCategoryUpdate: 'MEDICINE-CATEGORY_UPDATE',
  MedicineCategoryDelete: 'MEDICINE-CATEGORY_DELETE',
  // Medicine END

  // Storage START
  StorageProductRead: 'STORAGE-PRODUCT_READ',
  StorageProductCreate: 'STORAGE-PRODUCT_CREATE',
  StorageProductUpdate: 'STORAGE-PRODUCT_UPDATE',
  StorageProductDelete: 'STORAGE-PRODUCT_DELETE',
  StorageProductReport: 'STORAGE-PRODUCT_REPORT',
  StorageProductTransfer: 'STORAGE-PRODUCT_TRANSFER',
  StorageProductCategoryRead: 'STORAGE-PRODUCT-CATEGORY_READ',
  StorageProductCategoryCreate: 'STORAGE-PRODUCT-CATEGORY_CREATE',
  StorageProductCategoryUpdate: 'STORAGE-PRODUCT-CATEGORY_UPDATE',
  StorageProductCategoryDelete: 'STORAGE-PRODUCT-CATEGORY_DELETE',
  ProductTypeRead: 'PRODUCT-TYPE_READ',
  ProductTypeCreate: 'PRODUCT-TYPE_CREATE',
  ProductTypeUpdate: 'PRODUCT-TYPE_UPDATE',
  ProductTypeDelete: 'PRODUCT-TYPE_DELETE',
  ChemicalExposureUpdateLog: 'CHEMICAL-EXPOSURE_UPDATELOG',
  ChemicalExposureDurationManage: 'CHEMICAL-EXPOSURE-DURATION_MANAGE',
  // Storage END

  // Drill START
  DrillRead: 'DRILL_READ',
  DrillCreate: 'DRILL_CREATE',
  DrillUpdate: 'DRILL_UPDATE',
  DrillDelete: 'DRILL_DELETE',
  DrillDisable: 'DRILL_DISABLE',
  DrillEnable: 'DRILL_ENABLE',
  DrillPostpone: 'DRILL_POSTPONE',
  DrillPerform: 'DRILL_PERFORM',
  // Drill END

  // Task START
  TaskRead: 'TASK_READ',
  TaskCreate: 'TASK_CREATE',
  TaskUpdate: 'TASK_UPDATE',
  TaskDelete: 'TASK_DELETE',
  TaskDisable: 'TASK_DISABLE',
  TaskEnable: 'TASK_ENABLE',
  TaskPostpone: 'TASK_POSTPONE',
  TaskPerform: 'TASK_PERFORM',
  TaskRestore: 'TASK_RESTORE',
  HaccpCreate: 'HACCP_CREATE',
  HaccpUpdate: 'HACCP_UPDATE',
  HaccpDelete: 'HACCP_DELETE',
  HaccpPostpone: 'HACCP_POSTPONE',
  HaccpPerform: 'HACCP_PERFORM',
  HaccpUpdateLog: 'HACCP_UPDATELOG',
  // Task END

  // Maintenance START
  MaintenanceJobRead: 'MAINTENANCE-JOB_READ',
  MaintenanceJobCreate: 'MAINTENANCE-JOB_CREATE',
  MaintenanceJobUpdate: 'MAINTENANCE-JOB_UPDATE',
  MaintenanceJobDelete: 'MAINTENANCE-JOB_DELETE',
  MaintenanceJobDisable: 'MAINTENANCE-JOB_DISABLE',
  MaintenanceJobEnable: 'MAINTENANCE-JOB_ENABLE',
  MaintenanceJobPostpone: 'MAINTENANCE-JOB_POSTPONE',
  MaintenanceJobPerform: 'MAINTENANCE-JOB_PERFORM',
  MaintenanceJobPrint: 'MAINTENANCE-JOB_PRINT',
  MaintenanceJobReport: 'MAINTENANCE-JOB_REPORT',
  MaintenanceJobRestore: 'MAINTENANCE-JOB_RESTORE',
  ProjectRead: 'PROJECT_READ',
  ProjectCreate: 'PROJECT_CREATE',
  ProjectUpdate: 'PROJECT_UPDATE',
  ProjectDelete: 'PROJECT_DELETE',
  ProjectExport: 'PROJECT_EXPORT',
  ProjectComplete: 'PROJECT_COMPLETE',
  ServiceReportRead: 'SERVICE-REPORT_READ',
  ServiceReportCreate: 'SERVICE-REPORT_CREATE',
  ServiceReportUpdate: 'SERVICE-REPORT_UPDATE',
  ServiceReportDelete: 'SERVICE-REPORT_DELETE',
  ServiceReportPrint: 'SERVICE-REPORT_PRINT',
  CorrectiveActionRead: 'CORRECTIVE-ACTION_READ',
  CorrectiveActionCreate: 'CORRECTIVE-ACTION_CREATE',
  CorrectiveActionUpdate: 'CORRECTIVE-ACTION_UPDATE',
  CorrectiveActionDelete: 'CORRECTIVE-ACTION_DELETE',
  CorrectiveActionPrint: 'CORRECTIVE-ACTION_PRINT',
  CorrectiveActionPerform: 'CORRECTIVE-ACTION_PERFORM',
  MaintenanceJobTypeRead: 'MAINTENANCE-JOB-TYPE_READ',
  MaintenanceJobTypeCreate: 'MAINTENANCE-JOB-TYPE_CREATE',
  MaintenanceJobTypeUpdate: 'MAINTENANCE-JOB-TYPE_UPDATE',
  MaintenanceJobTypeDelete: 'MAINTENANCE-JOB-TYPE_DELETE',
  MaintenanceJobAreaRead: 'MAINTENANCE-JOB-AREA_READ',
  MaintenanceJobAreaCreate: 'MAINTENANCE-JOB-AREA_CREATE',
  MaintenanceJobAreaUpdate: 'MAINTENANCE-JOB-AREA_UPDATE',
  MaintenanceJobAreaDelete: 'MAINTENANCE-JOB-AREA_DELETE',
  ComponentRead: 'COMPONENT_READ',
  ComponentCreate: 'COMPONENT_CREATE',
  ComponentUpdate: 'COMPONENT_UPDATE',
  ComponentDelete: 'COMPONENT_DELETE',
  ComponentTransfer: 'COMPONENT_TRANSFER',
  ComponentGroupRead: 'COMPONENT-GROUP_READ',
  ComponentGroupCreate: 'COMPONENT-GROUP_CREATE',
  ComponentGroupUpdate: 'COMPONENT-GROUP_UPDATE',
  ComponentGroupDelete: 'COMPONENT-GROUP_DELETE',
  StandardJobTemplateRead: 'STANDARD-JOB-TEMPLATE_READ',
  StandardJobTemplateCreate: 'STANDARD-JOB-TEMPLATE_CREATE',
  StandardJobTemplateUpdate: 'STANDARD-JOB-TEMPLATE_UPDATE',
  StandardJobTemplateDelete: 'STANDARD-JOB-TEMPLATE_DELETE',
  MaintenanceSettingsUpdate: 'MAINTENANCE-SETTINGS_UPDATE',
  RuntimeRead: 'RUNTIME_READ',
  RuntimeCreate: 'RUNTIME_CREATE',
  RuntimeUpdate: 'RUNTIME_UPDATE',
  RuntimeDelete: 'RUNTIME_DELETE',
  RuntimeReport: 'RUNTIME_REPORT',
  RuntimeLogReport: 'RUNTIME_LOGREPORT',
  RuntimeImport: 'RUNTIME_IMPORT',
  // Maintenance END

  // Risk Assessment START
  RiskAssessmentRead: 'RISK-ASSESSMENT_READ',
  RiskAssessmentCreate: 'RISK-ASSESSMENT_CREATE',
  RiskAssessmentUpdate: 'RISK-ASSESSMENT_UPDATE',
  RiskAssessmentDelete: 'RISK-ASSESSMENT_DELETE',
  RiskAssessmentPrint: 'RISK-ASSESSMENT_PRINT',
  RiskAssessmentCopy: 'RISK-ASSESSMENT_COPY',
  RiskAssessmentHazardRead: 'RISK-ASSESSMENT-HAZARD_READ',
  RiskAssessmentHazardCreate: 'RISK-ASSESSMENT-HAZARD_CREATE',
  RiskAssessmentHazardUpdate: 'RISK-ASSESSMENT-HAZARD_UPDATE',
  RiskAssessmentHazardDelete: 'RISK-ASSESSMENT-HAZARD_DELETE',
  RiskAssessmentConsequenceRead: 'RISK-ASSESSMENT-CONSEQUENCE_READ',
  RiskAssessmentConsequenceCreate: 'RISK-ASSESSMENT-CONSEQUENCE_CREATE',
  RiskAssessmentConsequenceUpdate: 'RISK-ASSESSMENT-CONSEQUENCE_UPDATE',
  RiskAssessmentConsequenceDelete: 'RISK-ASSESSMENT-CONSEQUENCE_DELETE',
  RiskAssessmentLocationRead: 'RISK-ASSESSMENT-LOCATION_READ',
  RiskAssessmentLocationCreate: 'RISK-ASSESSMENT-LOCATION_CREATE',
  RiskAssessmentLocationUpdate: 'RISK-ASSESSMENT-LOCATION_UPDATE',
  RiskAssessmentLocationDelete: 'RISK-ASSESSMENT-LOCATION_DELETE',
  RiskAssessmentMitigatingMeasuresRead: 'RISK-ASSESSMENT-MITIGATING-MEASURES_READ',
  RiskAssessmentMitigatingMeasuresCreate: 'RISK-ASSESSMENT-MITIGATING-MEASURES_CREATE',
  RiskAssessmentMitigatingMeasuresUpdate: 'RISK-ASSESSMENT-MITIGATING-MEASURES_UPDATE',
  RiskAssessmentMitigatingMeasuresDelete: 'RISK-ASSESSMENT-MITIGATING-MEASURES_DELETE',
  RiskAssessmentOperationTypeRead: 'RISK-ASSESSMENT-OPERATION-TYPE_READ',
  RiskAssessmentOperationTypeCreate: 'RISK-ASSESSMENT-OPERATION-TYPE_CREATE',
  RiskAssessmentOperationTypeUpdate: 'RISK-ASSESSMENT-OPERATION-TYPE_UPDATE',
  RiskAssessmentOperationTypeDelete: 'RISK-ASSESSMENT-OPERATION-TYPE_DELETE',
  // Risk Assessment END

  // User START
  UserRead: 'USER_READ',
  UserCreate: 'USER_CREATE',
  UserUpdate: 'USER_UPDATE',
  UserDelete: 'USER_DELETE',
  UserRestore: 'USER_RESTORE',
  UserDeactivate: 'USER_DEACTIVATE',
  UserReactivate: 'USER_REACTIVATE',
  UserExport: 'USER_EXPORT',
  PaxRead: 'PAX_READ',
  PaxCreate: 'PAX_CREATE',
  PaxUpdate: 'PAX_UPDATE',
  PaxDelete: 'PAX_DELETE',
  MessagesSend: 'MESSAGES_SEND',
  MessagesRead: 'MESSAGES_READ',
  // User END

  // Department START
  DepartmentRead: 'DEPARTMENT_READ',
  DepartmentCreate: 'DEPARTMENT_CREATE',
  DepartmentUpdate: 'DEPARTMENT_UPDATE',
  DepartmentDelete: 'DEPARTMENT_DELETE',
  DepartmentGroupRead: 'DEPARTMENT-GROUP_READ',
  DepartmentGroupCreate: 'DEPARTMENT-GROUP_CREATE',
  DepartmentGroupUpdate: 'DEPARTMENT-GROUP_UPDATE',
  DepartmentGroupDelete: 'DEPARTMENT-GROUP_DELETE',
  // Department END

  // Alert START
  AlertRead: 'ALERT_READ',
  AlertCreate: 'ALERT_CREATE',
  AlertUpdate: 'ALERT_UPDATE',
  AlertDelete: 'ALERT_DELETE',
  // Alert END

  // Quantity Type START
  QuantityTypeRead: 'QUANTITY-TYPE_READ',
  QuantityTypeCreate: 'QUANTITY-TYPE_CREATE',
  QuantityTypeUpdate: 'QUANTITY-TYPE_UPDATE',
  QuantityTypeDelete: 'QUANTITY-TYPE_DELETE',
  // Quantity Type END

  // Menu START
  MenuRead: 'MENU_READ',
  MenuCreate: 'MENU_CREATE',
  MenuUpdate: 'MENU_UPDATE',
  MenuDelete: 'MENU_DELETE',
  // Menu END

  // Crew Management START
  ActivityRead: 'ACTIVITY_READ',
  ActivityCreate: 'ACTIVITY_CREATE',
  ActivityUpdate: 'ACTIVITY_UPDATE',
  ActivityDelete: 'ACTIVITY_DELETE',
  ShiftRead: 'SHIFT_READ',
  ShiftCreate: 'SHIFT_CREATE',
  ShiftUpdate: 'SHIFT_UPDATE',
  ShiftDelete: 'SHIFT_DELETE',
  PlannedActivityRead: 'PLANNED-ACTIVITY_READ',
  PlannedActivityCreate: 'PLANNED-ACTIVITY_CREATE',
  PlannedActivityUpdate: 'PLANNED-ACTIVITY_UPDATE',
  PlannedActivityDelete: 'PLANNED-ACTIVITY_DELETE',
  TripRead: 'TRIP_READ',
  TripCreate: 'TRIP_CREATE',
  TripUpdate: 'TRIP_UPDATE',
  TripDelete: 'TRIP_DELETE',
  TripPrint: 'TRIP_PRINT',
  TripComplete: 'TRIP_COMPLETE',
  TripPaxUpdate: 'TRIP_PAXUPDATE',
  TripPaxDelete: 'TRIP_PAXDELETE',
  TripPaxAdd: 'TRIP_PAXADD',
  TripCrewUpdate: 'TRIP_CREWUPDATE',
  TripCrewDelete: 'TRIP_CREWDELETE',
  TripCrewAdd: 'TRIP_CREWADD',
  PaxOverviewRead: 'PAX-OVERVIEW_READ',
  PaxOverviewCreate: 'PAX-OVERVIEW_CREATE',
  PaxOverviewUpdate: 'PAX-OVERVIEW_UPDATE',
  PaxOverviewDelete: 'PAX-OVERVIEW_DELETE',
  // Crew Management END

  // Forms START
  CustomFormRead: 'CUSTOM-FORM_READ',
  CustomFormCreate: 'CUSTOM-FORM_CREATE',
  CustomFormUpdate: 'CUSTOM-FORM_UPDATE',
  CustomFormDelete: 'CUSTOM-FORM_DELETE',
  CustomFormPrint: 'CUSTOM-FORM_PRINT',
  FormLibraryRead: 'FORM-LIBRARY_READ',
  FormLibraryCreate: 'FORM-LIBRARY_CREATE',
  FormLibraryUpdate: 'FORM-LIBRARY_UPDATE',
  FormLibraryDelete: 'FORM-LIBRARY_DELETE',
  FormLibraryPrint: 'FORM-LIBRARY_PRINT',
  // Forms END

  // Competence START
  CompetenceRead: 'COMPETENCE_READ',
  CompetenceCreate: 'COMPETENCE_CREATE',
  CompetenceUpdate: 'COMPETENCE_UPDATE',
  CompetenceDelete: 'COMPETENCE_DELETE',
  CompetenceGroupRead: 'COMPETENCE-GROUP_READ',
  CompetenceGroupCreate: 'COMPETENCE-GROUP_CREATE',
  CompetenceGroupUpdate: 'COMPETENCE-GROUP_UPDATE',
  CompetenceGroupDelete: 'COMPETENCE-GROUP_DELETE',
  CompetenceGroupRestore: 'COMPETENCE-GROUP_RESTORE',
  PositionRead: 'POSITION_READ',
  PositionCreate: 'POSITION_CREATE',
  PositionUpdate: 'POSITION_UPDATE',
  PositionDelete: 'POSITION_DELETE',
  PositionGroupRead: 'POSITION-GROUP_READ',
  PositionGroupCreate: 'POSITION-GROUP_CREATE',
  PositionGroupUpdate: 'POSITION-GROUP_UPDATE',
  PositionGroupDelete: 'POSITION-GROUP_DELETE',
  UserCompetenceRead: 'USER-COMPETENCE_READ',
  UserCompetenceCreate: 'USER-COMPETENCE_CREATE',
  UserCompetenceUpdate: 'USER-COMPETENCE_UPDATE',
  UserCompetenceDelete: 'USER-COMPETENCE_DELETE',
  UserCompetenceRenew: 'USER-COMPETENCE_RENEW',
  UserCompetenceMatrix: 'USER-COMPETENCE_MATRIX',
  UserCompetenceMatrixAdmin: 'USER-COMPETENCE_MATRIXADMIN',
  CompetenceRequirementRead: 'COMPETENCE-REQUIREMENT_READ',
  CompetenceRequirementCreate: 'COMPETENCE-REQUIREMENT_CREATE',
  CompetenceRequirementUpdate: 'COMPETENCE-REQUIREMENT_UPDATE',
  CompetenceRequirementDelete: 'COMPETENCE-REQUIREMENT_DELETE',
  RolesRead: 'ROLES_READ',
  RolesCreate: 'ROLES_CREATE',
  RolesUpdate: 'ROLES_UPDATE',
  RolesDelete: 'ROLES_DELETE',
  PrivilegeTemplateRead: 'PRIVILEGE-TEMPLATE_READ',
  PrivilegeTemplateCreate: 'PRIVILEGE-TEMPLATE_CREATE',
  PrivilegeTemplateUpdate: 'PRIVILEGE-TEMPLATE_UPDATE',
  PrivilegeTemplateDelete: 'PRIVILEGE-TEMPLATE_DELETE',
  // Competence END
} as const;
